import { TitleText } from '@calendly/ui/components/typography'
import Marked from 'marked-react'
import styled from 'astroturf/react'

import { useI18n } from 'locales'
import { Illustration } from 'components/confirmation/pages/personalized_confirmation/illustration'
import { useStatsigLayer } from 'hooks/use-statsig-layer'

import { Layout } from './layout'
import { Icons } from './icons'
import { SocialProof } from './social_proof'
import { NotetakerIllustration } from './notetaker_illustration'
import _IconSection from "index-IconSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/index.js?styleId=IconSection";
import _TitleContainer from "index-TitleContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/index.js?styleId=TitleContainer";
import _SubtitleWrapper from "index-SubtitleWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/index.js?styleId=SubtitleWrapper";


const IconSection = /*#__PURE__*/styled('div', null, {
  displayName: "IconSection",
  styles: _IconSection
})

const TitleContainer = /*#__PURE__*/styled('div', null, {
  displayName: "TitleContainer",
  styles: _TitleContainer
})

const SubtitleWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "SubtitleWrapper",
  styles: _SubtitleWrapper
})

const Hero = ({ illustration }) => {
  if (illustration === 'link') return <Illustration />
  if (illustration === 'link_animated') return <Illustration animate />
  if (illustration === 'icons') return <Icons />
  if (illustration === 'social_proof') return <SocialProof />
  if (illustration === 'notetaker_icon') return <NotetakerIllustration />
  return null
}

const getTitleAndSubtitle = (copyVariant) => {
  switch (copyVariant) {
    case 'free_notes':
      return {
        titleKey: 'booking.templates.signup_form.notetaker_discovery_variant_1.hero_title',
        subtitleKey: 'booking.templates.signup_form.notetaker_discovery_variant_1.hero_subtitle'
      }
    case 'capture_notes_signup':
      return {
        titleKey: 'booking.templates.signup_form.notetaker_discovery_variant_2.hero_title',
        subtitleKey: 'booking.templates.signup_form.notetaker_discovery_variant_2.hero_subtitle'
      }
    case 'capture_notes_benefits':
      return {
        titleKey: 'booking.templates.signup_form.notetaker_discovery_variant_3.hero_title',
        subtitleKey: 'booking.templates.signup_form.notetaker_discovery_variant_3.hero_subtitle'
      }
    case 'link_animated':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_link_animated.hero_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_link_animated.hero_subtitle'
      }
    case 'icons':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_icons.hero_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_icons.hero_subtitle'
      }
    case 'social_proof':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_social_proof.hero_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_social_proof.hero_subtitle'
      }
    case 'link':
    default:
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_link.hero_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_link.hero_subtitle'
      }
  }
}


export const MarketingBanner = () => {
  const { i18n } = useI18n()

  const confirmationLayer = useStatsigLayer('booking_flow_confirmation')

  const notetakerIllustration = confirmationLayer.get('confirmation_notetaker_illustration')
  const notetakerCopy = confirmationLayer.get('confirmation_notetaker_copy')
  const notetakerGradientCard = confirmationLayer.get('confirmation_notetaker_gradient_card')
  const illustrationVariant = confirmationLayer.get('confirmation_illustration_variant')
  const isTwoColumnDesign = confirmationLayer.get('confirmation_page_two_column_design')

  const effectiveIllustration = notetakerIllustration
    || illustrationVariant
    || (isTwoColumnDesign ? 'link' : null)
  const effectiveCopyVariant = notetakerCopy || illustrationVariant

  const { titleKey, subtitleKey } = getTitleAndSubtitle(effectiveCopyVariant)

  const title = i18n.t(titleKey)
  const subtitle = i18n.t(subtitleKey)

  const hasIllustration = !!effectiveIllustration

  return (
    <Layout variant={effectiveCopyVariant} gradientCard={!!notetakerGradientCard}>
      {(!!title || !!subtitle) && (
      <TitleContainer>
        <TitleText level={3}><Marked>{title}</Marked></TitleText>
        <SubtitleWrapper>
          <TitleText level={4} variant="normal"><Marked>{subtitle}</Marked></TitleText>
        </SubtitleWrapper>
      </TitleContainer>
      )}
      {hasIllustration && (
        <IconSection>
          <Hero illustration={effectiveIllustration} />
        </IconSection>
      )}
    </Layout>
  )
}
